import React from "react";
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";

const Tract3Table: React.FC = () => {
    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{
                borderRadius: 2,
                overflow: "hidden",
                border: "1px solid #d1c4e9",
                background:
                    "linear-gradient(to bottom, #efe7fb 0px, #efe7fb 10px, #f9f6ff 10px)"
            }}
        >
            <Table size="small">
                {/* En-têtes */}
                <TableHead>
                    <TableRow
                        sx={{
                            backgroundColor: "#4a0072"
                        }}
                    >
                        <TableCell
                            sx={{
                                width: "22%",
                                color: "#fff",
                                fontWeight: 700,
                                borderRight: "1px solid #311b92"
                            }}
                        >
                            {/* cellule vide pour les libellés de ligne */}
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{
                                color: "#fff",
                                fontWeight: 700,
                                borderRight: "1px solid #311b92"
                            }}
                        >
                            2018
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{
                                color: "#fff",
                                fontWeight: 700,
                                borderRight: "1px solid #311b92"
                            }}
                        >
                            2025
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ color: "#fff", fontWeight: 700 }}
                        >
                            Bilan
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {/* Trésorerie */}
                    <TableRow>
                        <TableCell
                            sx={{
                                fontWeight: 700,
                                borderRight: "1px solid #d1c4e9",
                                borderTop: "1px solid #d1c4e9"
                            }}
                        >
                            Trésorerie
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ borderRight: "1px solid #d1c4e9", borderTop: "1px solid #d1c4e9" }}
                        >
                            5,7&nbsp;M€
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ borderRight: "1px solid #d1c4e9", borderTop: "1px solid #d1c4e9" }}
                        >
                            1,6&nbsp;M€
                        </TableCell>
                        <TableCell
                            sx={{ borderTop: "1px solid #d1c4e9" }}
                        >
                            <Box display="flex" flexDirection="column" alignItems="flex-start">
                                <Typography fontWeight={700}>÷3</Typography>
                                <Typography variant="body2">
                                    Une division par 3 de la trésorerie
                                </Typography>
                            </Box>
                        </TableCell>
                    </TableRow>

                    {/* Endettement */}
                    <TableRow>
                        <TableCell
                            sx={{
                                fontWeight: 700,
                                borderRight: "1px solid #d1c4e9",
                                borderTop: "1px solid #d1c4e9"
                            }}
                        >
                            Endettement
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ borderRight: "1px solid #d1c4e9", borderTop: "1px solid #d1c4e9" }}
                        >
                            0,9&nbsp;M€
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ borderRight: "1px solid #d1c4e9", borderTop: "1px solid #d1c4e9" }}
                        >
                            4,5&nbsp;M€
                        </TableCell>
                        <TableCell
                            sx={{ borderTop: "1px solid #d1c4e9" }}
                        >
                            <Box display="flex" flexDirection="column" alignItems="flex-start">
                                <Typography fontWeight={700}>×5</Typography>
                                <Typography variant="body2">
                                    Une multiplication par 5 de l’endettement
                                </Typography>
                            </Box>
                        </TableCell>
                    </TableRow>

                    {/* Résultat annuel */}
                    <TableRow>
                        <TableCell
                            sx={{
                                fontWeight: 700,
                                borderRight: "1px solid #d1c4e9",
                                borderTop: "1px solid #d1c4e9"
                            }}
                        >
                            Résultat annuel
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ borderRight: "1px solid #d1c4e9", borderTop: "1px solid #d1c4e9" }}
                        >
                            +1,6&nbsp;M€
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ borderRight: "1px solid #d1c4e9", borderTop: "1px solid #d1c4e9" }}
                        >
                            –1,4&nbsp;M€
                        </TableCell>
                        <TableCell
                            sx={{ borderTop: "1px solid #d1c4e9" }}
                        >
                            <Box>
                                <Typography fontWeight={800}>
                                    Le 5<sup>e</sup> exercice déficitaire
                                </Typography>
                                <Typography variant="body2">
                                    Après 2019, 2021, 2022 et 2023, l’année 2025
                                    s’ajoute à la liste des exercices déficitaires,
                                    les seuls depuis 2008.
                                </Typography>
                            </Box>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default Tract3Table;
